<template>
  <div>
    <v-card color="warning"
            dark
            v-if="!user.is_email_verified"
            class="mb-4">
      <v-card-title class="py-1">
        User Is Not Verified Yet
      </v-card-title>
      <v-card-text class="py-1">
        <div>
          This user has not verified their account and set their password.
        </div>
      </v-card-text>
      <v-card-actions v-if="isAdmin"
                      class="px-4">
        <v-btn color="primary"
               :disabled="form.busy"
               @click.prevent="sendWelcomeEmail">
          Re-send email
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card color="warning"
            dark
            v-else-if="user.is_inactive"
            class="mb-4">
      <v-card-title class="py-1">
        User Disabled
      </v-card-title>
      <v-card-text class="py-1">
        <div>
          This user has been disabled. {{ user.first_name }} cannot use Mobile Locker.
        </div>
      </v-card-text>
      <v-card-actions v-if="isAdmin"
                      class="px-4">
        <v-btn v-if="team.has_seats_available"
               color="primary"
               :disabled="form.busy"
               @click.prevent="reactivate">
          Reactivate
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-else
            class="mb-4">
      <v-card-title class="py-1">
        User Active
      </v-card-title>
      <v-card-text class="py-1">
        <div>
          {{ user.first_name }} is active and can use Mobile Locker.
        </div>
      </v-card-text>
      <v-card-actions v-if="isAdmin"
                      class="px-4">
        <v-btn color="primary"
               :disabled="form.busy"
               @click.prevent="deactivate">
          Deactivate
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import DOMPurify from 'dompurify';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      form: new Form({
        status: '',
      })
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'team',
    ])
  },
  methods: {
    async deactivate() {
      if (confirm(`Are you sure you want to deactivate ${DOMPurify.sanitize(this.user.name)}? They will not be able to use Mobile Locker anymore.`)) {
        this.form.status = 'Locked';
        this.form.put(`/api/users/${this.user.id}/status`)
          .then(() => {
            this.$emit('updated');
          })
      }
    },
    reactivate() {
      this.form.status = 'Active';
      this.form.put(`/api/users/${this.user.id}/status`)
        .then(() => {
          this.$emit('updated');
        })
    },
    sendWelcomeEmail() {
      this.form.post(`/api/users/${this.user.id}/welcome`)
        .then(response => {
          if (response.data) {
            this.$toast.success(DOMPurify.sanitize(response.data.message));
          }
        })
    }
  }
}
</script>
